import React, { Fragment, useEffect } from 'react';
import useLearnosityProvider from 'chameleon/ui-stack/hooks/use-learnosity-provider';

const LearnosityProvider = (props) => {
  const {
    className,
    sessionId,
    itemReference,
    testReadyListener,
    readyListener,
    dataListener,
    errorListener,
    containerElement,
    apiType,
    initOptions,
    shouldDestroy = true,
  } = props;
  const { app, element, destroyLearnosityApi } = useLearnosityProvider({
    testReadyListener,
    readyListener,
    dataListener,
    errorListener,
    containerElement,
    apiType,
    initOptions,
    className,
    sessionId,
    itemReference,
  });

  useEffect(() => {
    return () => {
      if (app) {
        shouldDestroy && destroyLearnosityApi(app);
      }
    };
  }, [app]);

  return <Fragment>{element}</Fragment>;
};

LearnosityProvider.displayName = 'LearnosityProvider';

export default LearnosityProvider;
